var a=a=>a?.length==0;export{a as default};